import { render, staticRenderFns } from "./HeaderFooter.vue?vue&type=template&id=3b7c76e0&"
import script from "./HeaderFooter.vue?vue&type=script&lang=js&"
export * from "./HeaderFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports